const filterWorkshopTypes = (obj, bool = true) => {
  return Object.keys(obj).reduce((prev, current) => {
    if (obj[current]) {
      // eslint-disable-next-line no-param-reassign
      prev[current] = bool;
    }
    return prev;
  }, {});
};

export default filterWorkshopTypes;
